import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { buildBookingDetails } from '../utils'

export const useBookingState = (event, selectedProfessional) => {
  const authState = useSelector((state) => state.auth)
  const clinicsState = useSelector((state) => state.clinics?.data || [])

  const [loading, setLoading] = useState(false)
  const [patient, setPatient] = useState(null)
  const [service, setService] = useState(null)
  const [bookingDetails, setBookingDetails] = useState(null)
  const [selectedMedicalProfessional, setSelectedMedicalProfessional] = useState(selectedProfessional)
  const [addingPatient, setAddingPatient] = useState(false)
  const [activePatientTab, setActivePatientTab] = useState('search')

  const [bookingDate, setBookingDate] = useState(dayjs(event?.dateStr ? event?.dateStr : event.start))
  const [bookingStart, setBookingStart] = useState(
    event && event?.dateStr ? dayjs(event?.dateStr).format('HH:mm') : dayjs(event?.start).format('HH:mm')
  )

  useEffect(() => {
    // Enhanced auth state with clinic fallback
    const enhancedAuthState = {
      ...authState,
      agiliteUser: {
        ...authState.agiliteUser,
        extraData: {
          ...authState.agiliteUser?.extraData,
          // If no clinics assigned, use first available clinic as fallback
          clinics:
            authState.agiliteUser?.extraData?.clinics?.length > 0
              ? authState.agiliteUser.extraData.clinics
              : clinicsState.length > 0
              ? [clinicsState[0]._id]
              : []
        }
      }
    }

    const details = buildBookingDetails(
      patient,
      service,
      bookingDate,
      bookingStart,
      selectedMedicalProfessional,
      enhancedAuthState
    )

    // Only set booking details if validation passed
    if (details) {
      setBookingDetails(details)
    } else {
      setBookingDetails(null)
    }
    // eslint-disable-next-line
  }, [patient, service, bookingDate, bookingStart, clinicsState])

  const onAfterSuccessfulBooking = (setEvent, refreshFunction) => {
    if (event) {
      setEvent(null)
    }
    refreshFunction()
  }

  const resetSelections = () => {
    setPatient(null)
    setService(null)
    setSelectedMedicalProfessional(null)
  }

  // Determine what steps should be shown
  const showPatientSelection = selectedMedicalProfessional && bookingDate && bookingStart
  const showServiceSelection = patient && showPatientSelection
  const showFinalization = service && patient && bookingDetails?.service

  return {
    // State
    loading,
    setLoading,
    patient,
    setPatient,
    service,
    setService,
    bookingDetails,
    setBookingDetails,
    selectedMedicalProfessional,
    setSelectedMedicalProfessional,
    addingPatient,
    setAddingPatient,
    activePatientTab,
    setActivePatientTab,
    bookingDate,
    setBookingDate,
    bookingStart,
    setBookingStart,

    // Computed
    showPatientSelection,
    showServiceSelection,
    showFinalization,

    // Functions
    onAfterSuccessfulBooking,
    resetSelections
  }
}
